module.exports = __webpack_public_path__ + "img/category-favorite.486d44ac.png";